import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorListComponent } from './vendor-list/vendor-list.component';
import { MbscModule } from '@mobiscroll/angular';
import { NgbAccordionModule, NgbDropdownModule, NgbModalModule, NgbNavModule, NgbPaginationModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { VendorDetailComponent } from './vendor-detail/vendor-detail.component';
import { VendorPropertiesComponent } from './vendor-properties/vendor-properties.component';
import { VendorDefaultsComponent } from './vendor-defaults/vendor-defaults.component';
import { AssignEntityComponent } from './assign-entity/assign-entity.component';
import { RouterModule } from '@angular/router';
import { VendorNoteComponent } from './vendor-note/vendor-note.component';
import { UploadMasterComponent } from './upload-master/upload-master.component';
import { FileUploadModule } from 'ng2-file-upload';
import { VendorFileItemListComponent } from './vendor-file-item-list/vendor-file-item-list.component';
import { RenameVendorFileComponent } from './rename-vendor-file/rename-vendor-file.component';
import { VendorStatusListComponent } from './vendor-status-list/vendor-status-list.component';



@NgModule({
  declarations: [
    VendorListComponent,
    VendorDetailComponent,
    VendorPropertiesComponent,
    VendorDefaultsComponent,
    VendorNoteComponent,
    AssignEntityComponent,
    UploadMasterComponent,
    VendorFileItemListComponent,
    RenameVendorFileComponent,
    VendorStatusListComponent
  ],
  imports: [
    MbscModule,
    CommonModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbModalModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbPopoverModule,
    FormsModule,
    CoreModule,
    RouterModule,
    FileUploadModule,
  ]
})
export class VendorsModule { }
